var SCM = SCM || {};

SCM.PageTitleHelper = {};

SCM.PageTitleHelper.SetDynamicPageTitle = function (titleSelector) {
    var dynamicSearchTitle = $(titleSelector).val();
    if (dynamicSearchTitle) {
        document.title = dynamicSearchTitle;
    }
}